export const clientInfoAdapter = (data) => {
	console.log('clientInfoAdapter', data);
	return [
		{
			key: data?._id + 'client',
			auth: data?.info?.auth,
			commune: data?.info?.commune,
			email: data?.info?.email,
			first_name: data?.info?.first_name,
			last_name: data?.info?.last_name,
			location: data?.info?.location,
			phone: data?.info?.phone,
			rut: data?.info?.rut,
			schedule_selected: data?.info?.schedule_selected,
			street: data?.info?.street,
			street_number: data?.info?.street_number,
			type_house: data?.info?.type_house,
			type_retirement: data?.info?.type_retirement,
		},
	];
};
